import { initializeWorkflowAgentConversation } from "@mirage/mosaics/Chat/components/chat/instructions/initializeWorkflowAgentConversation";
import type { useWorkflowAgentConfig } from "@mirage/mosaics/ConversationAssistant/containers/ConversationAssistantPageContent/useRouteHandling";
import { CtaSource } from "@mirage/service-conversation/router_state_types";
import type { UserMessageOptions } from "@mirage/service-conversation/types";
import { getDashActionSurfaceComponentLoggingSource } from "@mirage/service-conversation/utils/loggingUtils";
import type { SetStateAction } from "react";
import { useEffect } from "react";

export function useWorkflowAgentHandling(
  variant: "default" | "condensed" | "workflow-agent-preview",
  workflowAgentConfig: ReturnType<typeof useWorkflowAgentConfig>,
  conversationId: string | undefined,
  setUserMessageOptions: (options: SetStateAction<UserMessageOptions>) => void,
  setSelectedModel: (model: string) => void,
) {
  useEffect(() => {
    if (
      variant === "workflow-agent-preview" &&
      workflowAgentConfig.workflowAgentFields
    ) {
      initializeWorkflowAgentConversation(
        workflowAgentConfig.workflowAgentFields.id,
        conversationId || "",
        getDashActionSurfaceComponentLoggingSource(CtaSource.WorkflowAgent),
        setUserMessageOptions,
      );
    }
  }, [
    variant,
    workflowAgentConfig.workflowAgentFields,
    conversationId,
    setUserMessageOptions,
  ]);

  useEffect(() => {
    if (workflowAgentConfig.model && workflowAgentConfig.model !== "default") {
      setSelectedModel(workflowAgentConfig.model);
    } else {
      // If we don't have a model from a workflow, set the model back to the default value
      setSelectedModel("");
    }
  }, [setSelectedModel, workflowAgentConfig.model]);
}
